import {Icon, Link} from '@ezcater/tapas';
import {faUpRightFromSquare} from '@fortawesome/pro-solid-svg-icons';
import useTranslation from 'next-translate/useTranslation';
import {twMerge} from 'tailwind-merge';

import useTracking from '@/hooks/useTracking';
import {CUSTOMER_HELP_CENTER_URL} from '@/paths';

const VisitHelpCenterCta: React.FC<{className?: string}> = ({className}) => {
  const {t} = useTranslation('common');
  const {trackClick} = useTracking();

  return (
    <Link
      href={CUSTOMER_HELP_CENTER_URL}
      onClick={() => trackClick('visit-help-center-cta')}
      target="_blank"
      rel="noopener noreferrer"
      className={twMerge(
        'flex w-full items-center justify-center gap-2 rounded-full bg-green-700 px-4 py-3 text-base font-bold text-white no-underline hover:bg-green-800',
        className,
      )}
    >
      {t('components.ContactUs.help.visitHelpCenter')}
      <Icon icon={faUpRightFromSquare} size="xsmall" className="text-sm" />
    </Link>
  );
};

export default VisitHelpCenterCta;
